import React from 'react';
import { DEMO_PROFILES } from '../data/demo';
import { FiHeart } from 'react-icons/fi';

const Likes = () => {
  const [showBlurred, setShowBlurred] = React.useState(true);
  const likes = DEMO_PROFILES.slice(0, 4);

  return (
    <div style={{ minHeight: '100vh', background: '#08080C', paddingBottom: 90 }}>
      <div style={{ padding: '16px 20px 0' }}>
        <h1 style={{ fontSize: 26, fontWeight: 800, marginBottom: 4 }}>Likes You</h1>
        <p style={{ fontSize: 14, color: '#71717A' }}>{likes.length} people liked your profile</p>
      </div>

      <div style={{ padding: '20px 16px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 12 }}>
          {likes.map((p, i) => (
            <div key={p._id} style={{
              borderRadius: 20, overflow: 'hidden', position: 'relative', aspectRatio: 3/4,
              background: '#111118',
              filter: showBlurred ? 'blur(12px)' : 'none',
              transition: 'filter 0.3s ease',
            }}>
              <img src={p.photos?.[0]} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                onError={(e) => { e.target.src = `https://ui-avatars.com/api/?name=${p.name}&background=1A1A24&color=FF3D71&size=400`; }} />
              <div style={{
                position: 'absolute', bottom: 0, left: 0, right: 0,
                background: 'linear-gradient(transparent, rgba(0,0,0,0.8))',
                padding: '40px 12px 12px',
              }}>
                <h4 style={{ fontSize: 15, fontWeight: 600 }}>{p.name}</h4>
              </div>
              <div style={{
                position: 'absolute', top: 10, right: 10,
                width: 28, height: 28, borderRadius: 14,
                background: 'rgba(255,61,113,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}>
                <FiHeart size={14} style={{ color: '#FF3D71' }} />
              </div>
            </div>
          ))}
        </div>

        {showBlurred && (
          <div style={{
            position: 'absolute', left: 0, right: 0, top: 100,
            display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
            padding: 40, zIndex: 10,
          }}>
            <div style={{
              padding: '28px 24px', borderRadius: 24,
              background: 'rgba(17,17,24,0.95)', border: '1px solid rgba(255,255,255,0.08)',
              backdropFilter: 'blur(20px)', textAlign: 'center', maxWidth: 300,
            }}>
              <div style={{ fontSize: 48, marginBottom: 12 }}>👀</div>
              <h3 style={{ fontSize: 20, fontWeight: 700, marginBottom: 8 }}>See Who Likes You</h3>
              <p style={{ fontSize: 13, color: '#71717A', marginBottom: 20, lineHeight: 1.5 }}>
                Upgrade to VIBE Premium to see who liked your profile and find your match faster.
              </p>
              <button onClick={() => setShowBlurred(false)} style={{
                padding: '12px 24px', borderRadius: 14,
                background: 'linear-gradient(135deg, #FF3D71, #8B5CF6)',
                color: '#FFFFFF', border: 'none', fontSize: 14, fontWeight: 600,
                fontFamily: 'Inter', cursor: 'pointer',
                boxShadow: '0 4px 20px rgba(255,61,113,0.3)',
              }}>Unlock Now</button>
              <p style={{ fontSize: 11, color: '#52525B', marginTop: 10 }}>₹199/month • Cancel anytime</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Likes;
